import React, { useRef, useState } from "react";
import "./Manufacturer.css";
import Icons from "../../../../Config/Images";
import Header from "../Common/Header";
import { UploadMediaRequestAPI } from "../../../../Store/Action/mediaAction";
import { useDispatch } from "react-redux";
import { BASE_URL } from "../../../../Constants/AppConstants";
import { createManufacturerAPIUrl } from "../../../../Store/Action/manufacturerAction";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { getCityStateDistrictByPinCode } from "../../../../Store/Action/onboardingAction";
import Footer from "../../Layout/Footer/Footer";

const ManufacturerPage = () => {
  const navigate = useNavigate();
  // States for form data, errors, and questions
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    whatsAppNumber: "",
    userEmail: "",
    shopName: "",
    address: "",
    pinCode: "",
    city: "",
    district: "",
    state: "",
    occupation: "",
    // stockistOrManufacturer: "",
    // visitingCardFile: "",
  });

  const [vistingCardFileImage, setVisitingCardFileImage] = useState("");
  const [fileType, setFileType] = useState("");

  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const visitingCardRef = useRef(null);
  const userOnboardingDetails = null; // Example placeholder for pre-filled data
  const userOnboardingQuestions = {}; // Example placeholder for custom questions

  // Handle input changes
  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   let newValue = value;
  //   if (name === "whatsAppNumber" || name === "pinCode") {
  //     // Keep only numeric values
  //     newValue = value.replace(/\D/g, "") || null;
  //   } else {
  //     newValue = value === "" ? null : value;
  //   }
  //   setFormData((prevData) => ({ ...prevData, [name]: value }));

  //   // Remove error message if the user starts typing in the field
  //   setErrors((prevErrors) => ({
  //     ...prevErrors,
  //     [name]: value.trim() ? "" : prevErrors[name],
  //   }));
  // };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;

    if (name === "whatsAppNumber") {
      // Keep only numeric values and limit length to 10
      newValue = value.replace(/\D/g, "").slice(0, 10) || null;
    } else if (name === "pinCode") {
      // Keep only numeric values and limit length to 6
      newValue = value.replace(/\D/g, "").slice(0, 6) || null;
    } else {
      newValue = value.trim() === "" ? null : value;
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: newValue, // Use the cleaned newValue
    }));

    // Remove error message if the user starts typing in the field
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  // Handle validation on blur
  const handleFormFieldChange = (e) => {
    const { name, value } = e.target;
    const newErrors = { ...errors };

    // Convert camelCase to separate words and ensure lowercase
    const formattedName = name.replace(/([A-Z])/g, " $1").toLowerCase();
    if (!value.trim()) {
      // newErrors[name] = `${name.replace(/([A-Z])/g, " $1")} is required`;
      // newErrors[name] = `${name.toLowerCase()} is required`;
      newErrors[name] = `${formattedName} is required`;
    } else {
      delete newErrors[name];
    }

    setErrors(newErrors);
  };

  // Mock function for handling PIN code on mouse out
  const handleMouseOutForPinCode = (e) => {
    const pinCode = formData.pinCode;
    dispatch(
      getCityStateDistrictByPinCode(pinCode, (result) => {
        if (result?.status) {
          setFormData({
            ...formData,
            state: result?.data?.user_state,
            // city: result?.data?.user_city,
            district: result?.data?.user_district,
          });
        }
      })
    );
  };

  const FileUpload = React.forwardRef(
    ({ label, value, onChange, error, onmouseoutFunction, preview }, ref) => (
      <div className="questionsUpload" onBlur={onmouseoutFunction}>
        {/* <label className="label-become-a-manuf">{label}</label> */}
        <label className="label-become-a-manuf">
          {label}
          <span className="asterisk-red">*</span>
        </label>
        <div
          className="custom-file-upload"
          onClick={() => ref.current && ref.current.click()}
        >
          {/* {preview && (
            <img
              src={`${preview}`}
              alt="Doc Uploaded"
              className="file-upload-preview"
            />
          )} */}
          {/* Conditionally render PDF icon or Image */}
          {fileType === "application/pdf" ? (
            <img
              src={Icons?.default_pdf_icon} // PDF icon
              alt="PDF Uploaded"
              className="file-upload-preview-pdf"
            />
          ) : (
            preview && (
              <img
                src={preview}
                alt="Image Uploaded"
                className="file-upload-preview"
              />
            )
          )}
          <input
            // style={styles.input}
            type="text"
            placeholder={preview ? "" : "No file chosen"}
            readOnly
            className="file-input-text"
            value={value || ""}
          />
          <input
            // style={styles.input}
            type="file"
            ref={ref}
            className="file-input-hidden"
            accept=".pdf,.jpg,.jpeg,.png"
            onChange={onChange}
          />
          {/* {preview} */}
          <button
            type="button"
            className="browse-button"
            style={{ marginTop: "0px" }}
          >
            Browse
          </button>
        </div>

        {error && <div className="error">{error}</div>}
      </div>
    )
  );

  const handleFileChange = (ref, fieldName) => {
    const file = ref.current?.files[0];
    if (file) {
      // Update form data with the file name
      // setFormData((prev) => ({
      //   ...prev,
      //   [fieldName]: file.name,
      // }));
      // Clear any previous errors
      setErrors((prevErrors) => ({
        ...prevErrors,
        [fieldName]: "",
      }));
    }
    // Now you can directly use the file object in the upload request
    const selectedFiles = [file]; // Directly use the File object
    // const selectedFiles = [
    //   {
    //     fileName: file.name,
    //     type: file.type,
    //     // uri: file.uri || URL.createObjectURL(file),
    //     driveName: "onboardingDocuments",
    //   },
    // ];

    dispatch(
      UploadMediaRequestAPI(
        selectedFiles,
        "manufacturerQueryDocument",
        false,
        (result) => {
          if (result.status) {
            const fileType = result?.data?.[0]?.file_storage_type;
            const fileUrl = result?.data?.[0]?.file_url;
            setFormData((prev) => ({
              ...prev,
              [fieldName]: result.data[0].file_storage_id,
            }));
            setErrors((prevErrors) => ({
              ...prevErrors,
              [fieldName]: "",
            }));
            // setVisitingCardFileImage(result?.data?.[0]?.file_url);
            // Store file type and file URL separately
            setVisitingCardFileImage(fileUrl);
            setFileType(fileType); // Store file type in state
          }
        }
      )
    );
  };

  const handleSubmitBtn = (e) => {
    e.preventDefault();

    let newErrors = {};

    // Validate first name
    if (!formData.firstName?.trim()) {
      newErrors.firstName = "First name is required";
    }

    // Validate last name
    if (!formData.lastName?.trim()) {
      newErrors.lastName = "Last name is required";
    }

    // Validate WhatsApp number
    if (!formData.whatsAppNumber?.trim()) {
      newErrors.whatsAppNumber = "WhatsApp number is required";
    } else if (!/^[6789]\d{9}$/.test(formData.whatsAppNumber)) {
      newErrors.whatsAppNumber = "Enter a valid 10-digit number";
    }

    if (!formData.userEmail?.trim()) {
      newErrors.userEmail = "Email is required.";
    } else if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
        formData.userEmail
      )
    ) {
      newErrors.userEmail = "Enter a valid email address.";
    }

    if (!formData.shopName?.trim()) {
      newErrors.shopName = "Shop name is required.";
    }
    if (!formData.address?.trim()) {
      newErrors.address = "Address is required.";
    }
    if (!formData.pinCode?.trim()) {
      newErrors.pinCode = "Pin code is required.";
    } else if (!/^\d{6}$/.test(formData.pinCode)) {
      newErrors.pinCode = "Enter a valid 6-digit pin code.";
    }

    if (!formData.city?.trim()) {
      newErrors.city = "City is required.";
    }
    if (!formData.district?.trim()) {
      newErrors.district = "District is required.";
    }
    if (!formData.state?.trim()) {
      newErrors.state = "State is required.";
    }
    if (!formData.occupation?.trim()) {
      newErrors.occupation = "Occupation is required.";
    }
    // if (!formData.stockistOrManufacturer) {
    //   newErrors.businessType = "Please select Stockist or Manufacturer.";
    // }
    // if (!formData.visitingCardFile) {
    //   newErrors.visitingCardFile = "Visiting card file is required.";
    // }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    const payloadData = {
      manufacturer_first_name: formData?.firstName,
      manufacturer_last_name: formData?.lastName,
      manufacturer_email: formData?.userEmail,
      manufacturer_address: formData?.address,
      manufacturer_shop_name: formData?.shopName,
      manufacturer_whatsapp_number: formData?.whatsAppNumber,
      manufacturer_state: formData?.state,
      manufacturer_city: formData?.city,
      manufacturer_pincode: formData?.pinCode,
      manufacturer_district: formData?.district,
      manufacturer_occupation: formData?.occupation,
      // manufacturer_type: formData?.stockistOrManufacturer,
      // manufacturer_visiting_card_id: formData?.visitingCardFile,
    };

    dispatch(
      createManufacturerAPIUrl(payloadData, (result) => {
        if (result?.status) {
          toast.success(result?.data?.message);
          setFormData(() => {
            return {
              firstName: "",
              lastName: "",
              whatsAppNumber: "",
              userEmail: "",
              shopName: "",
              address: "",
              pinCode: "",
              city: "",
              district: "",
              state: "",
              occupation: "",
              // stockistOrManufacturer: "",
              // visitingCardFile: "",
            };
          });
          navigate("/");
        } else {
          toast.error(result?.error?.message);
        }
      })
    );
  };
  return (
    <div>
      <div className="section-1-div" style={{ position: "sticky", top: 0 }}>
        <Header />
      </div>
      <div className="below-div-form">
        <h2 className="main-heading-text">
          Business Partnership Inquiry – Let’s Collaborate!
        </h2>
        {/* <h2 className="main-heading-text">Become A Manufacturer</h2> */}
        <form>
          {/* Full Name */}

          <div className="form-group">
            <label className="label-become-a-manuf">
              1. Your Name? <span className="asterisk-red">*</span>
            </label>
            <div className="main-form-view">
              <div className="left-side-div-become-a-manuf">
                <input
                  // style={styles.input}
                  className="input-become-a-manuf"
                  type="text"
                  id="firstName"
                  name="firstName"
                  placeholder="First Name"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  // onBlur={handleFormFieldChange}
                />
                {errors.firstName && (
                  <div className="error">{errors.firstName}</div>
                )}
              </div>
              <div className="right-side-div">
                <input
                  // style={styles.input}
                  className="input-become-a-manuf"
                  type="text"
                  id="lastName"
                  name="lastName"
                  placeholder="Last Name"
                  value={formData.lastName}
                  onChange={handleInputChange}
                  // onBlur={handleFormFieldChange}
                />
                {errors.lastName && (
                  <div className="error">{errors.lastName}</div>
                )}
              </div>
            </div>
          </div>

          {/* WhatsApp Number */}
          <div className="form-group">
            <label className="label-become-a-manuf">
              2.{" "}
              {/* {userOnboardingQuestions.whatAppNumber ||
                "Enter your WhatsApp number? "} */}
              Contact Information <span className="asterisk-red">*</span>
            </label>
            <input
              // style={styles.input}
              className="input-become-a-manuf"
              type="tel"
              id="whatsAppNumber"
              name="whatsAppNumber"
              maxLength={10}
              placeholder="Whatsapp Number"
              value={formData.whatsAppNumber || ""}
              onChange={handleInputChange}
              // onBlur={handleFormFieldChange}
            />
            {errors.whatsAppNumber && (
              <div className="error">{errors.whatsAppNumber}</div>
            )}
          </div>

          {/* Email */}
          <div className="form-group">
            {/* <label className="label-become-a-manuf">
              3.{" "}
              {userOnboardingQuestions.userEmail ||
                "What is your email address? "}{" "}
              <span className="asterisk-red">*</span>
            </label> */}
            <input
              // style={styles.input}
              className="input-become-a-manuf"
              type="email"
              id="userEmail"
              name="userEmail"
              placeholder="Email Address"
              value={formData.userEmail}
              onChange={handleInputChange}
              // onBlur={handleFormFieldChange}
            />
            {errors.userEmail && (
              <div className="error">{errors.userEmail}</div>
            )}
          </div>

          <div className="form-group">
            <label className="label-become-a-manuf">
              {/* {userOnboardingQuestions.userEmail ||
                "4. What is the name of your shop? "}{" "} */}
              3. Business Details
              <span className="asterisk-red">*</span>
            </label>
            <input
              // style={styles.input}
              className="input-become-a-manuf"
              type="shopName"
              id="shopName"
              name="shopName"
              placeholder="Name of Your Business/Shop"
              value={formData.shopName}
              onChange={handleInputChange}
              // onBlur={handleFormFieldChange}
            />
            {errors.shopName && <div className="error">{errors.shopName}</div>}
          </div>

          {/* Address */}
          <div className="form-group">
            <label className="label-become-a-manuf">
              {/* 5. {userOnboardingQuestions.address || "What is your address ? "}{" "} */}
              4. Business Address
              <span className="asterisk-red">*</span>
            </label>
            <div className="main-form-view">
              <div className="left-side-div-become-a-manuf">
                <input
                  // style={styles.input}
                  className="input-become-a-manuf"
                  type="text"
                  id="address"
                  name="address"
                  placeholder="Address Line"
                  value={formData.address}
                  onChange={handleInputChange}
                  // onBlur={handleFormFieldChange}
                />
                {errors.address && (
                  <div className="error">{errors.address}</div>
                )}
              </div>

              <div className="right-side-div">
                <input
                  // style={styles.input}
                  className="input-become-a-manuf"
                  type="text"
                  id="pinCode"
                  name="pinCode"
                  placeholder="Pin Code"
                  value={formData.pinCode || ""}
                  onChange={handleInputChange}
                  onBlur={(e) => {
                    handleMouseOutForPinCode(e);
                  }}
                  // onBlur={(e) => {
                  //   handleMouseOutForPinCode(e);
                  //   handleFormFieldChange(e);
                  // }}
                />
                {errors.pinCode && (
                  <div className="error">{errors.pinCode}</div>
                )}
              </div>
            </div>

            <div className="main-form-view">
              <div className="left-side-div-become-a-manuf">
                <input
                  // style={styles.input}
                  className="input-become-a-manuf"
                  type="text"
                  id="city"
                  name="city"
                  placeholder="City"
                  value={formData.city}
                  maxLength={50}
                  onChange={handleInputChange}
                  // onBlur={handleFormFieldChange}
                />
                {errors.city && <div className="error">{errors.city}</div>}
              </div>

              <div className="right-side-div">
                <input
                  // style={styles.input}
                  className="input-become-a-manuf"
                  type="text"
                  id="district"
                  name="district"
                  placeholder="District"
                  value={formData.district}
                  maxLength={50}
                  onChange={handleInputChange}
                />
                {errors.district && (
                  <div className="error">{errors.district}</div>
                )}
              </div>
            </div>

            <input
              // style={styles.input}
              className="input-become-a-manuf"
              type="text"
              id="state"
              name="state"
              placeholder="State"
              value={formData.state}
              onChange={handleInputChange}
              maxLength={50}
              // onBlur={handleFormFieldChange}
            />
            {errors.state && <div className="error">{errors.state}</div>}
          </div>

          <div className="form-group">
            <label className="label-become-a-manuf">
              5. Professional Background <span className="asterisk-red">*</span>
            </label>
            <input
              // style={styles.input}
              className="input-become-a-manuf"
              type="occupation"
              id="occupation"
              name="occupation"
              placeholder="Your Occupation/Role"
              value={formData.occupation}
              onChange={handleInputChange}
              // onBlur={handleFormFieldChange}
            />
            {errors.occupation && (
              <div className="error">{errors.occupation}</div>
            )}
          </div>
          {/* <div className="form-group">
            <div className="question-style">
              <div className="que">
                <label className="label-become-a-manuf">
                  6. Are you a stockist or a manufacturer?{" "}
                  <span className="asterisk-red">*</span>
                </label>
              </div>
              <div className="inp-btns">
                <button
                  type="button"
                  className={`yes-btn ${
                    formData.stockistOrManufacturer === "Stockist"
                      ? "active"
                      : ""
                  }`}
                  onClick={() => {
                    setFormData({
                      ...formData,
                      stockistOrManufacturer: "Stockist",
                    });
                    // Clear error message when selection is made
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      businessType: "",
                    }));
                  }}
                  // style={{
                  //   ...styles.yesBtn,
                  //   ...(formData.retailerOrWholesaler === "Stockist" && {
                  //     backgroundColor: "#d3d3d3",
                  //   }),
                  //   ...(errors.businessType && { borderColor: "red" }),
                  // }}
                  onMouseOut={handleFormFieldChange}
                >
                  Stockist
                </button>
                <button
                  type="button"
                  className={`no-btn ${
                    formData.stockistOrManufacturer === "Manufacturer"
                      ? "active"
                      : ""
                  }`}
                  onClick={() => {
                    setFormData({
                      ...formData,
                      stockistOrManufacturer: "Manufacturer",
                    });
                    // Clear error message when selection is made
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      businessType: "",
                    }));
                  }}
                  // style={{
                  //   ...styles.noBtn,
                  //   ...(formData.retailerOrWholesaler === "Manufacturer" && {
                  //     backgroundColor: "#d3d3d3",
                  //   }),
                  //   ...(errors.businessType && { borderColor: "red" }),
                  // }}
                  onMouseOut={handleFormFieldChange}
                >
                  Manufacturer
                </button>
                {errors.businessType && (
                  <div className="error">{errors.businessType}</div>
                )}
              </div>
            </div>
          </div> */}

          {/* <div className="form-group">
            <FileUpload
              label="7. Could you upload your visiting card ? "
              ref={visitingCardRef}
              preview={vistingCardFileImage}
              // value={formData.}
              onChange={() =>
                handleFileChange(visitingCardRef, "visitingCardFile")
              }
              // onmouseoutFunction={handleFormFieldChange}
              error={errors.visitingCardFile}
            />
          </div> */}

          <button
            onClick={(e) => handleSubmitBtn(e)}
            type="next"
            className="submit-btn"
          >
            Submit
          </button>
        </form>
      </div>
      <Footer />
    </div>
  );
};

export default ManufacturerPage;
